module.exports = __webpack_public_path__ + "media/images/wedding/top/feature-detail-background-c4dab7a3a8b4241c7ff400190c645927.jpg";